import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ExpandedListTab from '../ExpandedListTab';
import MutationButton from '../buttons/MutationButton';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import { SYNCHRONIZE_OAAD_LDAP } from '../../graphql/settings';

function OaadLdapDetailTab() {
    const { t } = useTranslation();
    const synchronizeOaadLdapMutation = useExtendedMutation(SYNCHRONIZE_OAAD_LDAP, {
        successMessageOptions: { key: 'settings.oaad-ldap.sync-success', dataProperty: 'synchronizeOaadLdap' },
        failureMessageOptions: { key: 'settings.oaad-ldap.sync-failure' },
        withCorrelationId: false,
    });
    return (
        <ExpandedListTab
            className="settings-detail-tab"
        >
            <MutationButton
                className="sync-oaad-ldap-button button-bordered button"
                confirmationMessage={t('settings.oaad-ldap.sync-confirmation-message')}
                extendedMutation={synchronizeOaadLdapMutation}
                showConfirmationDialog
            >
                <FontAwesomeIcon icon="check" />&nbsp;{t('settings.oaad-ldap.sync-oaad-ldap-button')}
            </MutationButton>
        </ExpandedListTab>
    );
}

export default OaadLdapDetailTab;
